var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "pagination",
      attrs: { role: "navigation", "aria-label": "pagination" }
    },
    [
      _c(
        "ul",
        { staticClass: "pagination-list" },
        [
          _c(
            "li",
            { staticClass: "pagination-prev", attrs: { tabindex: "0" } },
            [
              _c("span", { staticClass: "pagination-previous sr-only" }, [
                _vm._v("Previous page")
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "icon icon-angle-double-left",
                attrs: { disabled: _vm.pagination.current_page <= 1 },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.pagination.current_page - 1)
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changePage(_vm.pagination.current_page - 1)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.pages, function(page) {
            return _c(
              "li",
              {
                staticClass: "pagination-page",
                attrs: { tabindex: "0", "aria-label": "Page " + page }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "pagination-link",
                    class: _vm.isCurrentPage(page) ? "active" : "",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changePage(page)
                      },
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.changePage(page)
                      }
                    }
                  },
                  [_vm._v(_vm._s(page))]
                )
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "pagination-next", attrs: { tabindex: "0" } },
            [
              _c("span", { staticClass: "pagination-next sr-only" }, [
                _vm._v("Next page")
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "icon icon-angle-double-right",
                attrs: {
                  disabled:
                    _vm.pagination.current_page >= _vm.pagination.end_page
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.pagination.current_page + 1)
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changePage(_vm.pagination.current_page + 1)
                  }
                }
              })
            ]
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33dcf2ce", { render: render, staticRenderFns: staticRenderFns })
  }
}